import { Typography } from "@commonlibs";
import styled, { css } from "styled-components";

export const ScheduleCalendarRoot = styled.div(
    () => css`
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 48px;
        padding: 0 16px;
        border: 1px solid #26262614;
        border-radius: 7.5px;
    `,
);

export const CalendarValue = styled(Typography)<{ hasValue: boolean }>(
    ({ theme, hasValue }) => css`
        position: absolute;
        color: ${hasValue ? theme.palette.gray[900] : "#26262633"};
    `,
);

export const PopoverTrigger = styled.div(
    () => css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
    `,
);

export const DayPickerRoot = styled.div(
    () => css`
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        align-items: center;
        width: 380px;
        height: 260px;
        padding: 15px 20px;
        column-gap: 8px;
        box-sizing: border-box;
    `,
);

export const DayRoot = styled.span<{ selected?: boolean }>(
    ({ theme, selected }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;

        ${selected &&
        css`
            background-color: ${theme.palette.primary};
            color: white;
        `}

        &:hover {
            background-color: ${selected ? theme.palette.primary : "#eee"};
        }
    `,
);
